import styled from "styled-components";

export const Sessao = styled.div`
  width: 100%;
  margin: 20px 0 120px;
  padding: 0 30px;
  @media screen and (max-width: 414px) {
    padding: 0 24px;
  }
`;

export const Container = styled.div`
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  justify-content: center;
  align-items: center;

  > p {
    width: 100%;
    overflow-wrap: break-word;
    align-self: flex-start;
    font-size: 25px;
    color: #071242;
    font-weight: 500;
    margin-bottom: 20px;
    @media screen and (max-width: 1366px) {
      font-size: 23px;
    }
    @media screen and (max-width: 768px) {
      font-size: 20px;
    }
  }
`;

export const Info = styled.div`
  display: flex;
  align-self: flex-start;

  p + p {
    margin-left: 20px;
    @media screen and (max-width: 768px) {
      margin-left: 10px;
    }
    @media screen and (max-width: 400px) {
      margin-top: 10px;
      margin-left: 0;
    }
  }

  p {
    display: flex;
    font-size: 15px;
    font-weight: normal;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #071242;
    @media screen and (max-width: 1366px) {
      font-size: 13px;
    }
    @media screen and (max-width: 768px) {
      font-size: 10px;
    }
  }

  @media screen and (max-width: 400px) {
    flex-direction: column;
  }

  svg {
    margin-right: 5px;
  }
`;

export const Content = styled.div`
  align-self: flex-start;
  max-width: 800px;
  width: 100%;
  margin-top: 20px;
  overflow-wrap: break-word;

  p + p {
    margin-top: 20px;
  }
  p {
    font-size: 15px;
    line-height: 1.5;
    color: #071242;
    text-align: start;
    margin: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 20px 0;
  }

  img {
    width: 100% !important;
    height: auto !important;
  }
`;

export const Categorias = styled.p`
  display: -webkit-box !important;
  -webkit-line-clamp: 1 !important;
  -webkit-box-orient: vertical !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
`;
